import axiosClient from './axiosClient';
import { ActivityType } from 'types/activityLog';

export const getActivityLogs = async (
  page: number = 1,
  limit: number = 10,
  name?: string,
  fromDate?: string,
  toDate?: string,
) => {
  try {
    const params: any = { page, limit };

    if (name) params.name = name;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axiosClient.get('/activity-logs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching activity logs:', error);
    throw error;
  }
};
